import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";

import { I18nProvider } from "@/contexts/I18nContext";
import { MemberProvider } from "@/contexts/MemberContext";
import { AdminAuthProvider } from "@/contexts/AdminAuthContext";

import { PublicShell } from "@/components/PublicShell";
import { RegistrationGate } from "@/components/RegistrationGate";
import RegisterScreen from "@/pages/RegisterScreen";
import LookupScreen from "@/pages/LookupScreen";
import HomePage from "@/pages/HomePage";
import EventsPage from "@/pages/EventsPage";
import GivePage from "@/pages/GivePage";
import GiveSuccessPage from "@/pages/GiveSuccessPage";
import GalleryPage from "@/pages/GalleryPage";
import SocialPage from "@/pages/SocialPage";
import PrayersPage from "@/pages/PrayersPage";
import SurveyPage from "@/pages/SurveyPage";

import { AdminShell } from "@/components/admin/AdminShell";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminNews from "@/pages/admin/AdminNews";
import AdminEvents from "@/pages/admin/AdminEvents";
import AdminPhotos from "@/pages/admin/AdminPhotos";
import AdminMembers from "@/pages/admin/AdminMembers";
import AdminDonations from "@/pages/admin/AdminDonations";
import AdminCelebrations from "@/pages/admin/AdminCelebrations";
import AdminEmail from "@/pages/admin/AdminEmail";
import AdminNotifications from "@/pages/admin/AdminNotifications";
import AdminPrayers from "@/pages/admin/AdminPrayers";
import AdminAccounts from "@/pages/admin/AdminAccounts";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminSurvey from "@/pages/admin/AdminSurvey";
import AdminTeam from "@/pages/admin/AdminTeam";
import TeamPage from "@/pages/TeamPage";

function App() {
  return (
    <I18nProvider>
      <MemberProvider>
        <AdminAuthProvider>
          <BrowserRouter>
            <Routes>
              {/* Public PWA */}
              <Route path="/register" element={<RegisterScreen />} />
              <Route path="/lookup" element={<LookupScreen />} />
              <Route element={<PublicShell />}>
                <Route path="/" element={<RegistrationGate><HomePage /></RegistrationGate>} />
                <Route path="/events" element={<RegistrationGate><EventsPage /></RegistrationGate>} />
                <Route path="/give" element={<RegistrationGate><GivePage /></RegistrationGate>} />
                <Route path="/give/success" element={<RegistrationGate><GiveSuccessPage /></RegistrationGate>} />
                <Route path="/gallery" element={<RegistrationGate><GalleryPage /></RegistrationGate>} />
                <Route path="/prayers" element={<RegistrationGate><PrayersPage /></RegistrationGate>} />
                <Route path="/survey" element={<RegistrationGate><SurveyPage /></RegistrationGate>} />
                <Route path="/social" element={<RegistrationGate><SocialPage /></RegistrationGate>} />
                {/* PUBLIC — no RegistrationGate: visible to unregistered visitors too */}
                <Route path="/team" element={<TeamPage />} />
              </Route>

              {/* Admin */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route element={<AdminShell />}>
                <Route path="/admin" element={<AdminDashboard />} />
                <Route path="/admin/news" element={<AdminNews />} />
                <Route path="/admin/events" element={<AdminEvents />} />
                <Route path="/admin/photos" element={<AdminPhotos />} />
                <Route path="/admin/members" element={<AdminMembers />} />
                <Route path="/admin/celebrations" element={<AdminCelebrations />} />
                <Route path="/admin/donations" element={<AdminDonations />} />
                <Route path="/admin/notifications" element={<AdminNotifications />} />
                <Route path="/admin/prayers" element={<AdminPrayers />} />
                <Route path="/admin/email" element={<AdminEmail />} />
                <Route path="/admin/accounts" element={<AdminAccounts />} />
                <Route path="/admin/survey" element={<AdminSurvey />} />
                <Route path="/admin/team" element={<AdminTeam />} />
                <Route path="/admin/settings" element={<AdminSettings />} />
              </Route>

              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <Toaster richColors position="top-center" />
          </BrowserRouter>
        </AdminAuthProvider>
      </MemberProvider>
    </I18nProvider>
  );
}

export default App;
